export default "/images/vendor/flag-icons/flags/1x1/km.svg?f07a34b8d0a9f8910177fd6a0f631964";